// extracted by mini-css-extract-plugin
export default {"-large":"W6AGJc8j55S56LcIeA7U","croppingPresetItem":"PusMJmNUQASJRgtPwUeg"};